import { render, staticRenderFns } from "./registroVisitas.vue?vue&type=template&id=f399da84&scoped=true&lang=pug&"
import script from "./registroVisitas.vue?vue&type=script&lang=js&"
export * from "./registroVisitas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f399da84",
  null
  
)

export default component.exports